const LIMIT_MESSAGE_SHOW_THRESHOLD = 0.8;

/**
 * Calculates limit state based on current value length
 */
export function getLimitState(
  valueLength: number,
  limit?: number
): { limitAlmostReached: boolean; limitReached: boolean } {
  const hasLimit = limit !== undefined;
  const limitAlmostReached =
    hasLimit && valueLength / limit >= LIMIT_MESSAGE_SHOW_THRESHOLD;
  const limitReached = hasLimit && valueLength >= limit;

  return { limitAlmostReached, limitReached };
}
